export default {
  DSTU2: 'dstu2',
  STU3: 'stu3',
  R4: 'r4',
};
